// src/components/sections/BlogContent.jsx
import "./BlogContent.css";
import Divider from  "../ui/Divider"


function BlogContent() {
  return (
    <div className="blog-content">
      <h2>
        Een integraal platform voor het meten van de cliënt­ervaring
        van jeugdigen met uw dienstverlening
      </h2>
      <p className="subtitle">Ontdek de uitgebreide mogelijkheden</p>
      <Divider/>

      <div className="highlight-box">
        Binnen het platform van ContinuMee meten we de cliënt­ervaring
        van kinderen en hun ouders en jongeren met de jeugdzorg binnen
        de inkoopregio Holland-Rijnland. Het platform biedt vele
        mogelijkheden van het monitoren en sturen op de respons tot het
        kunnen bevragen van survey-data met onze nieuwe virtuele AI
        Agent Almee.
      </div>

      <h3>Over het platform</h3>
      <p>
        Binnen het platform meten we de ervaringen van jongeren en ouders
        van kinderen met de jeugdhulp in de regio Holland Rijnland. Het
        platform is er op gericht om niet alleen kwantitatieve data op te
        halen maar ook om verhalenderwijs ervaringen van jeugdigen en
        ouders/verzorgers te verzamelen.
      </p>

      <div className="image-grid">
        <img src="balloon-kid.png" alt="Kind met ballonnen" />
        <img src="icecream-kids.png" alt="Kinderen met tablet" />
        <img src="climbing-kid.png" alt="Kind klimt" />
      </div>

      <h3>Gericht rappelleren</h3>
      <p>
        Voor de regio Holland-Rijnland hebben we het platform ingericht op
        basis van het proces waarbij aanbieders de vragenlijsten uitzetten
        onder de kinderen die bij hen in zorg zijn.
      </p>

      <h3>Nieuw! Almee, jouw virtuele onderzoeker</h3>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque
        tellus vel pretium posuere. Id maecenas a tristique in fusce
        hendrerit...
      </p>
    </div>
  );
}

export default BlogContent;